/* Couchpotato — Collection page behaviour.
   Read-more, keyword type filter + count, client-side pagination, per-card carousel.
   Idempotent + theme-editor aware. No dependencies. */
(function () {
  function setup(root) {
    if (root.dataset.cpcReady) return;
    root.dataset.cpcReady = '1';

    /* read more — reveal only when the 3-line clamped text actually overflows */
    var heroIn = root.querySelector('.cpc-hero-in');
    var more = root.querySelector('.cpc-more');
    var lede = root.querySelector('.cpc-lede');
    if (heroIn && more && lede) {
      if (lede.scrollHeight - lede.clientHeight > 2) more.hidden = false;
      more.addEventListener('click', function () {
        heroIn.classList.add('cpc-expanded');
        more.hidden = true;
      });
    }

    var cards = [].slice.call(root.querySelectorAll('.cpc-card'));
    var typeBtns = [].slice.call(root.querySelectorAll('.cpc-type'));
    var countEl = root.querySelector('.cpc-count');
    var countWord = (countEl && countEl.dataset.word) || 'produkter';
    var pager = root.querySelector('.cpc-pager');
    var gridW = root.querySelector('.cpc-grid-w');
    var perPage = parseInt(root.dataset.perPage, 10) || 12;

    var currentFilter = 'all';
    var page = 1;

    function matches(card) {
      if (currentFilter === 'all') return true;
      return (card.dataset.type || '').split(' ').indexOf(currentFilter) > -1;
    }
    function scrollToGrid() {
      if (!gridW) return;
      var y = gridW.getBoundingClientRect().top + window.scrollY - 70;
      if (window.scrollY > y) window.scrollTo({ top: y, behavior: 'smooth' });
    }

    function render() {
      var filtered = cards.filter(matches);
      var pages = Math.max(1, Math.ceil(filtered.length / perPage));
      if (page > pages) page = pages;
      var start = (page - 1) * perPage;
      cards.forEach(function (c) { c.style.display = 'none'; });
      filtered.slice(start, start + perPage).forEach(function (c) { c.style.display = ''; });
      if (countEl) countEl.textContent = filtered.length + ' ' + countWord;
      renderPager(pages);
    }

    function pageBtn(label, target, opts) {
      opts = opts || {};
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cpc-page' + (opts.on ? ' cpc-on' : '') + (opts.nav ? ' cpc-page-nav' : '');
      b.innerHTML = label;
      if (opts.disabled) { b.disabled = true; }
      else b.addEventListener('click', function () { page = target; render(); scrollToGrid(); });
      return b;
    }
    function renderPager(pages) {
      if (!pager) return;
      pager.innerHTML = '';
      if (pages <= 1) { pager.hidden = true; return; }
      pager.hidden = false;
      pager.appendChild(pageBtn('&lsaquo;', Math.max(1, page - 1), { nav: true, disabled: page === 1 }));
      for (var i = 1; i <= pages; i++) pager.appendChild(pageBtn(String(i), i, { on: i === page }));
      pager.appendChild(pageBtn('&rsaquo;', Math.min(pages, page + 1), { nav: true, disabled: page === pages }));
    }

    typeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        typeBtns.forEach(function (x) { x.classList.remove('cpc-on'); });
        b.classList.add('cpc-on');
        currentFilter = b.dataset.t;
        page = 1;
        render();
        scrollToGrid();
      });
    });

    /* per-card image carousel */
    cards.forEach(function (card) {
      var imgs = [].slice.call(card.querySelectorAll('.cpc-fig > img'));
      var dots = [].slice.call(card.querySelectorAll('.cpc-dots span'));
      if (imgs.length < 2) return;
      var idx = 0;
      function show(i) {
        idx = (i + imgs.length) % imgs.length;
        var im = imgs[idx];
        if (im && !im.getAttribute('src') && im.dataset.src) { im.src = im.dataset.src; } // load alt image on demand
        imgs.forEach(function (m, k) { m.classList.toggle('cpc-on', k === idx); });
        dots.forEach(function (d, k) { d.classList.toggle('cpc-on', k === idx); });
      }
      [].slice.call(card.querySelectorAll('.cpc-nav')).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          show(idx + Number(b.dataset.dir));
        });
      });

      /* touch: swipe the image area instead of the (hidden) arrows */
      var fig = card.querySelector('.cpc-fig');
      if (!fig) return;
      var sx = 0, sy = 0, dx = 0, dy = 0, axis = null, swiped = false;

      fig.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        dx = 0; dy = 0; axis = null; swiped = false;
      }, { passive: true });

      fig.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        dx = e.touches[0].clientX - sx;
        dy = e.touches[0].clientY - sy;
        if (!axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (axis === 'x' && e.cancelable) e.preventDefault(); // keep vertical scrolling, swallow the sideways drag
      }, { passive: false });

      fig.addEventListener('touchend', function () {
        if (axis !== 'x' || Math.abs(dx) < 40) return;
        show(idx + (dx < 0 ? 1 : -1));
        swiped = true; // the click that follows must not open the product
      });

      card.addEventListener('click', function (e) {
        if (!swiped) return;
        swiped = false;
        e.preventDefault(); e.stopPropagation();
      }, true);
    });

    render();
  }

  function boot(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-section-type="cp-collection"]')).forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
